var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.04,
    height: 89.524,
    viewBox: "0 0 125.04 89.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_150",
    "data-name": "Groupe 150",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M611.292,364.922H542.868a3.636,3.636,0,0,0-3.632,3.632v11.089a3.636,3.636,0,0,0,3.632,3.633h68.424a3.636,3.636,0,0,0,3.633-3.633V368.555A3.636,3.636,0,0,0,611.292,364.922Z",
    transform: "translate(-489.949 -338.688)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M340.354,653.978H313.132a.218.218,0,1,1,0-.436h27.222a.218.218,0,1,1,0,.436Z",
    transform: "translate(-312.915 -564.454)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M411.949,341.272a2.042,2.042,0,0,0-.419,3.1l-1.979,4.226,2.275,1.829,2.711-6.007a2.053,2.053,0,0,0-2.588-3.151Z",
    transform: "translate(-388.506 -319.934)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M363.385,348.852h0a2.844,2.844,0,0,1,3.829.858l4.049,6.063,1.406-3.1a.871.871,0,0,1,1.053-.471l2.122.663a.871.871,0,0,1,.565,1.111l-1.453,4.289a3.706,3.706,0,0,1-5.61,1.866h0a3.706,3.706,0,0,1-.607-.522l-5.968-6.376a2.844,2.844,0,0,1,.612-4.381Z",
    transform: "translate(-351.314 -325.799)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M413.331,321.542a.41.41,0,0,1,.4.42l-.035,1.407.071.006-.025.956-.069-.009-.125,5.042a.711.711,0,0,1-.636.689l-3.206.337a.538.538,0,0,1-.593-.572l.486-7.179a.666.666,0,0,1,.562-.613l3.1-.481h0A.4.4,0,0,1,413.331,321.542Z",
    transform: "translate(-388.161 -304.755)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M411.918,322.953l1.627-.253a.135.135,0,0,0,.113-.118h0a.153.153,0,0,1,.128-.134l.343-.053a.323.323,0,0,1,.373.327l-.176,7.31a.369.369,0,0,1-.337.359l-3.2.285a.285.285,0,0,1-.31-.3l.432-7.113a.46.46,0,0,1,.389-.427l.361-.056A.23.23,0,0,0,411.918,322.953Z",
    transform: "translate(-389.23 -305.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M69.519,364.452h2.49l1.184-9.6H69.518Z",
    transform: "translate(-54.379 -277.572)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M0,0H7.825V3.023h-4.8A3.023,3.023,0,0,1,0,0Z",
    transform: "translate(22.431 89.192) rotate(179.995)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M34.383,364.452h2.49l1.184-9.6H34.382Z",
    transform: "translate(-26.894 -277.572)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M0,0H7.825V3.023h-4.8A3.023,3.023,0,0,1,0,0Z",
    transform: "translate(14.78 89.192) rotate(179.995)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 5.349,
    cy: 5.349,
    r: 5.349,
    transform: "translate(9.431 9.091)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M355.075,349.462a8.245,8.245,0,0,0-3.981-6.8c-1.382-.814-2.894-1.132-4.1.072a8.353,8.353,0,0,0-1.706,2.561,11,11,0,0,0-.2,8.165l2.864,7.913,6.629.718a.871.871,0,0,0,.964-.9Z",
    transform: "translate(-337.542 -320.712)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M348.724,426.7s-4.953,1.849-3.658,9.678c1.162,7.025.239,30.343.037,35.056a.87.87,0,0,0,.8.9l2.891.241a.871.871,0,0,0,.938-.774l1.493-13.714a.218.218,0,0,1,.433.005l1.113,13.2a.871.871,0,0,0,.9.8l2.428-.077a.871.871,0,0,0,.843-.9l-1.43-43.5Z",
    transform: "translate(-337.896 -387.015)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M352.544,282.473a3.877,3.877,0,1,0-1.7-5.817,3.694,3.694,0,0,0-4.9-1.136,5.675,5.675,0,0,0-2.619,4.676,12.9,12.9,0,0,0,1.151,5.427,5.922,5.922,0,0,0,7.492,3.144A5.154,5.154,0,0,1,352.544,282.473Z",
    transform: "translate(-336.691 -268.386)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M416.232,339.633a.219.219,0,0,1-.132-.044l0,0-.5-.381a.221.221,0,0,1,.269-.351l.322.247.761-.993a.221.221,0,0,1,.31-.041h0l0,.007,0-.007a.221.221,0,0,1,.041.31l-.9,1.167a.221.221,0,0,1-.176.086Z",
    transform: "translate(-393.17 -317.647)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M611.587,244.458H543.164a3.636,3.636,0,0,0-3.632,3.633v11.089a3.636,3.636,0,0,0,3.632,3.633h68.424a3.636,3.636,0,0,0,3.632-3.633V248.09A3.636,3.636,0,0,0,611.587,244.458Zm3.25,14.721a3.255,3.255,0,0,1-3.25,3.25H543.164a3.255,3.255,0,0,1-3.25-3.25V248.09a3.255,3.255,0,0,1,3.25-3.25h68.424a3.255,3.255,0,0,1,3.25,3.25Z",
    transform: "translate(-490.18 -244.458)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M597.44,270.21a6.322,6.322,0,1,1,6.322-6.322A6.322,6.322,0,0,1,597.44,270.21Z",
    transform: "translate(-530.532 -254.711)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M704,299.313H671.14a1.53,1.53,0,0,1,0-3.059H704a1.53,1.53,0,0,1,0,3.059Z",
    transform: "translate(-591.931 -284.974)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M682.016,269.464H671.14a1.529,1.529,0,0,1,0-3.059h10.876a1.529,1.529,0,1,1,0,3.059Z",
    transform: "translate(-591.931 -261.626)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395-2",
    "data-name": "Path 395",
    d: "M610.167,277.761a.724.724,0,0,1-.435-.145l-.008-.006-1.639-1.254a.728.728,0,0,1,.886-1.156l1.061.814,2.508-3.272a.728.728,0,0,1,1.021-.135h0l-.016.022.016-.022a.729.729,0,0,1,.135,1.021l-2.95,3.847a.729.729,0,0,1-.579.284Z",
    transform: "translate(-543.581 -266.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M476.587,381.458H408.164a3.636,3.636,0,0,0-3.633,3.633v11.089a3.636,3.636,0,0,0,3.633,3.632h68.423a3.636,3.636,0,0,0,3.633-3.632V385.09A3.636,3.636,0,0,0,476.587,381.458Z",
    transform: "translate(-384.579 -351.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M476.587,381.458H408.164a3.636,3.636,0,0,0-3.633,3.633v11.089a3.636,3.636,0,0,0,3.633,3.632h68.423a3.636,3.636,0,0,0,3.633-3.632V385.09A3.636,3.636,0,0,0,476.587,381.458Zm3.25,14.721a3.255,3.255,0,0,1-3.25,3.25H408.164a3.255,3.255,0,0,1-3.25-3.25V385.09a3.255,3.255,0,0,1,3.25-3.25h68.423a3.255,3.255,0,0,1,3.25,3.25Z",
    transform: "translate(-384.579 -351.623)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M462.44,407.21a6.323,6.323,0,1,1,6.323-6.322A6.323,6.323,0,0,1,462.44,407.21Z",
    transform: "translate(-424.932 -361.875)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M569,436.313H536.14a1.529,1.529,0,1,1,0-3.059H569a1.529,1.529,0,0,1,0,3.059Z",
    transform: "translate(-486.331 -392.139)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M547.016,406.464H536.14a1.529,1.529,0,1,1,0-3.059h10.876a1.53,1.53,0,0,1,0,3.059Z",
    transform: "translate(-486.331 -368.791)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395-3",
    "data-name": "Path 395",
    d: "M475.166,414.761a.724.724,0,0,1-.435-.145l-.008-.006-1.639-1.254a.728.728,0,1,1,.886-1.156l1.061.814,2.508-3.272a.728.728,0,0,1,1.021-.135h0l-.016.022.016-.022a.729.729,0,0,1,.135,1.021l-2.95,3.847a.729.729,0,0,1-.579.284Z",
    transform: "translate(-437.981 -373.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M383.764,392.365a2.042,2.042,0,0,0-2.787,1.428l-4.6.788-.2,2.912,6.48-1.2a2.053,2.053,0,0,0,1.109-3.924Z",
    transform: "translate(-362.398 -360.028)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M353.708,353.668h0a2.844,2.844,0,0,1,1.481,3.634l-2.666,6.786,3.347-.615a.871.871,0,0,1,.988.6l.667,2.12a.871.871,0,0,1-.589,1.1l-4.351,1.256a3.706,3.706,0,0,1-4.734-3.54h0a3.7,3.7,0,0,1,.082-.8l1.828-8.54a2.844,2.844,0,0,1,3.946-2Z",
    transform: "translate(-340.244 -329.69)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanned);
export default __webpack_public_path__ + "static/media/planned.c2fe8851.svg";
export { ForwardRef as ReactComponent };